"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hindSiliguri = void 0;
var css_1 = require("@emotion/css");
(0, css_1.injectGlobal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @import url('https://fonts.googleapis.com/css?family=Hind+Siliguri:300,400,500,600,700&display=swap&bengali,latin-ext');\n"], ["\n  @import url('https://fonts.googleapis.com/css?family=Hind+Siliguri:300,400,500,600,700&display=swap&bengali,latin-ext');\n"])));
exports.hindSiliguri = "'Hind Siliguri', sans-serif";
var templateObject_1;
//# sourceMappingURL=index.js.map